"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let Constants = /** @class */ (() => {
    class Constants {
    }
    Constants.BUCKET_ID = "bucketId";
    Constants.BUCKET_SECRET_NAME = 'x-eusi-bucket-secret';
    Constants.BUCKET_ID_NAME = 'x-eusi-bucket-id';
    Constants.AUTHORIZATION_TOKEN_NAME = 'x-eusi-user-auth-token';
    Constants.AUTHORIZATION_TOKEN_ALTERNATE_NAME = 'authorization';
    return Constants;
})();
exports.default = Constants;
//# sourceMappingURL=constants.js.map